/* eslint-disable global-require */
import React from 'react';
import { Helmet } from 'react-helmet';
import injectLayout from 'components/MainLayout';
import { compose } from 'react-apollo';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import {
  Header,
  Divider,
  Container,
  Button,
  Grid,
  Image,
  Card,
  List,
  Icon,
} from 'semantic-ui-react';
import OwlCarousel from 'react-owl-carousel';
import sampleSize from 'lodash/sampleSize';
import Routes from 'config/routes';
import styles from './index.css';
import ShopCard from './ShopCard';

const stores = [
  // {
  //   name: 'amazon',
  //   url: 'https://www.amazon.com/',
  //   img: require('./assets/sec-4/amazon-us.png'),
  // },
  // {
  //   name: 'ebay',
  //   url: 'https://www.ebay.com/',
  //   img: require('./assets/sec-4/ebay.png'),
  // },
  // {
  //   name: 'walmart',
  //   url: 'https://www.walmart.com/',
  //   img: require('./assets/sec-4/walmart.png'),
  // },
  // {
  //   name: 'ali express',
  //   url: 'https://www.aliexpress.us/',
  //   img: require('./assets/sec-4/aliexpress.png'),
  // },
  {
    name: 'shein',
    url: 'https://www.shein.com/',
    img: require('./assets/sec-4/shein.jpg'),
  },
  {
    name: 'guess',
    url: 'https://www.guess.com/us',
    img: require('./assets/sec-4/guess.jpg'),
  },
  {
    name: 'sephora',
    url: 'https://www.sephora.com/',
    img: require('./assets/sec-4/sephora.jpg'),
  },
  {
    name: 'adidas',
    url: 'https://www.adidas.com/us',
    img: require('./assets/sec-4/adidas.jpg'),
  },
  {
    name: 'ck',
    url: 'https://www.calvinklein.us/en',
    img: require('./assets/sec-4/ck.jpg'),
  },
  {
    name: 'carters',
    url: 'https://www.carters.com/',
    img: require('./assets/sec-4/carters.jpg'),
  },
  {
    name: 'mk',
    url: 'https://www.michaelkors.com/',
    img: require('./assets/sec-4/mk.jpg'),
  },
  {
    name: 'gap',
    url: 'https://www.gap.com/',
    img: require('./assets/sec-4/gap.jpg'),
  },
];

const testimonials = [
  {
    id: 1,
    src: require('./assets/sec-5/reviews-section-5/review_1.jpg'),
  },
  {
    id: 2,
    src: require('./assets/sec-5/reviews-section-5/review-2.jpg'),
  },
  {
    id: 3,
    src: require('./assets/sec-5/reviews-section-5/review-3.jpg'),
  },
  {
    id: 4,
    src: require('./assets/sec-5/reviews-section-5/review-4.jpg'),
  },
  {
    id: 5,
    src: require('./assets/sec-5/reviews-section-5/review-5.jpg'),
  },
  {
    id: 6,
    src: require('./assets/sec-5/reviews-section-5/review-6.jpg'),
  },
];
// eslint-disable-next-line react/prefer-stateless-function
class ComeBack extends React.Component {
  constructor() {
    super();
    this.state = {
      videoModalOpen: false,
      products: '',
      loading: true,
    };
    this.pageNum = Math.floor(Math.random() * 2) + 1;
  }

  componentDidMount() {
    this.getShopData();
  }

  getShopData() {
    fetch('https://api.lynks.com/shop-graphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: `
          query products($isWarehouse: Boolean,$page:Int) {
            products(isWarehouse:$isWarehouse,page:$page){
              nodes{
                sortedSelectors{
                  type
                  values
                }
                minPriceEgp
                maxPriceEgp
                title
                slug
                id
                defaultPhoto{
                  id
                  url_small
                }
                minShippingDays
                maxShippingDays
                variations{
                  colorSlugs
                  selectors{
                    type
                    value
                  }
                }
                defaultVariation {
                  selectors {
                    type
                    value
                  }
                  listPriceEgp
                  priceEgp
                  photos {
                    url
                    url_small
                  }
                }
              }
            }
          }
        `,
        variables: {
          isWarehouse: true,
          page: this.pageNum,
        },
      }),
    })
      .then((res) => res.json())
      .then((result) =>
        this.setState({ products: result.data.products.nodes, loading: false })
      )
      .catch((err) => console.log(err));
  }
  render() {
    const isAr = this.props.intl.locale === 'ar';
    const rowCount = window.innerWidth > 1200 ? 4 : 2;
    return (
      <div>
        <Helmet>
          <title>
            {isAr
              ? 'تسوق بلا حدود من ماركات عالمية في أمريكا ، إنجلترا أو الامارات'
              : 'Discover endless options from top international brands with Lynks'}
          </title>
          <meta
            name="description"
            content={
              isAr
                ? 'مع أفضل تجربة أونلاين شوبنج في مصر لينكس تتيح لك الشراء من ملايين المتاجر الإلكترونية حول العالم بخصومات على الشحن الدولي وتتحمل عنك حتى 100 % من مصاريف الجمارك'
                : 'Millions of online stores around the world with discounts on international shipping and bear up to 100% of customs fees to get your order in Egypt at the best price'
            }
          />
        </Helmet>

        <div>
          {/* above the fold */}
          <div
            className={isAr ? styles.container : styles.containerEn}
            style={{
              color: '#fff',
            }}
          >
            <Container style={{ padding: '7em 0' }}>
              <Header style={{ color: '#fff' }} id={styles.mainHeader}>
                {isAr ? 'تجربة تسوق مثالية' : 'Experience a shopping spree'}
              </Header>
              <Header style={{ color: '#fff' }} id={styles.mainHeader}>
                {isAr ? 'أكثر من كل الأوقات' : 'like never before'}
              </Header>

              <Divider hidden />

              <Header
                size="large"
                style={{
                  margin: '0.4rem 0',
                  color: '#fff',
                  fontWeight: 'normal',
                }}
                className={styles.textCenter}
              >
                {isAr
                  ? 'تسوق من كل المتاجر العالمية بلا حدود مع لينكس'
                  : 'Discover endless options from top international brands with Lynks'}
              </Header>

              <Divider hidden />
              <Divider hidden />
              <Header
                size="huge"
                style={{ color: '#fff', margin: '1rem auto' }}
                className={styles.textCenter}
              >
                {isAr
                  ? 'عرض استثنائي بانتظارك:'
                  : 'A special OFFER just for You:'}
              </Header>
              <List size="huge" className={styles.textCenter}>
                <List.Item>
                  <List.Icon name="check" />
                  <List.Content className={styles.smallerText}>
                    {isAr
                      ? 'خصم ٧٥٪ على الجمارك و مصاريف الخدمة'
                      : '75% discount on customs and service fees'}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Icon name="check" />
                  <List.Content className={styles.smallerText}>
                    {isAr
                      ? 'خصم ٥٠٪ على الشحن الدولي'
                      : '50% discount on international shipping'}
                  </List.Content>
                </List.Item>
                <List.Item>
                  <List.Icon name="check" />
                  <List.Content className={styles.smallerText}>
                    {isAr ? 'ساري لمدة 30 يوم فقط' : 'valid only for 30 days'}
                  </List.Content>
                </List.Item>
              </List>

              <Divider section hidden />
              <Header
                size="huge"
                style={{ color: '#fff' }}
                className={styles.textCenter}
              >
                {isAr ? 'كود الخصم : WB' : 'Discount Code: WB'}
              </Header>
              <Divider section hidden />

              <Button
                size="massive"
                style={{
                  borderRadius: '1rem',
                  padding: '1.5rem 2rem',
                  backgroundColor: '#fff',
                  color: '#ff5400',
                  fontSize: '2rem',
                }}
                id={styles.hover}
                as="a"
                href={Routes.Cart}
                className={styles.btnCenter}
              >
                {isAr ? 'اشتري الآن' : 'Buy Now'}
              </Button>
            </Container>
          </div>
          {/* icons */}
          <div>
            <Container style={{ padding: '1em 0' }}>
              <Divider hidden />
              <Grid columns="equal" textAlign="center">
                <Grid.Column mobile={8} computer={4}>
                  <Image
                    size="tiny"
                    centered
                    src={require('./assets/Sec-1/icon_1.png')}
                  />
                  <Header
                    as="h3"
                    style={{ textAlign: 'center', color: '#626262' }}
                  >
                    {isAr ? 'شراء' : 'Quick'}
                    <br />
                    {isAr ? 'سريع' : 'purchase'}
                  </Header>
                  <Divider hidden />
                </Grid.Column>
                <Grid.Column mobile={8} computer={4}>
                  <Image
                    size="tiny"
                    centered
                    src={require('./assets/Sec-1/icon_2.png')}
                  />
                  <Header
                    as="h3"
                    style={{ textAlign: 'center', color: '#626262' }}
                  >
                    {isAr ? 'شحن دولي' : 'Fast'}
                    <br />
                    {isAr ? 'أسرع' : 'international shipping'}
                  </Header>
                  <Divider hidden />
                </Grid.Column>
                <Grid.Column mobile={8} computer={4}>
                  <Image
                    size="tiny"
                    centered
                    src={require('./assets/Sec-1/icon_3.png')}
                  />
                  <Header
                    as="h3"
                    style={{ textAlign: 'center', color: '#626262' }}
                  >
                    {isAr ? 'تسهيلات' : 'Payment'}
                    <br />
                    {isAr ? 'في الدفع' : 'facilities'}
                  </Header>
                  <Divider hidden />
                </Grid.Column>
                <Grid.Column mobile={8} computer={4}>
                  <Image
                    size="tiny"
                    centered
                    src={require('./assets/Sec-1/icon_4.png')}
                  />
                  <Header
                    as="h3"
                    style={{ textAlign: 'center', color: '#626262' }}
                  >
                    {isAr ? 'خدمة عملاء' : 'Professional'}
                    <br />
                    {isAr ? 'احترافية' : ' customer service'}
                  </Header>
                  <Divider hidden />
                </Grid.Column>
              </Grid>
            </Container>
          </div>
          {/* icons2 */}
          <div
            style={{
              borderTop: '1px solid #dadada',
              backgroundColor: '#F4F1F2',
            }}
          >
            <Container id="stores" style={{ padding: '5em 0' }}>
              <Divider hidden />
              <Header as="h1" textAlign="center" id={styles.mainHeader}>
                {isAr
                  ? 'ابدأ تجربة تسوق بلا حدود مع لينكس'
                  : 'Start Unlimited Shopping Experience with Lynks'}
              </Header>

              <Divider section hidden />

              <Grid columns="equal" textAlign="center">
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={8} computer={5}>
                    <Image
                      size="tiny"
                      centered
                      src={require('./assets/Sec-2/icon_1-sec2.svg')}
                    />
                    <Header as="h3" style={{ textAlign: 'center' }}>
                      {isAr ? 'شراء سريع' : 'Quick purchase'}
                    </Header>
                    <p
                      style={{
                        color: '#7a7a7a',
                        fontSize: '1.25rem',
                      }}
                    >
                      {isAr
                        ? 'في خلال ساعتين فقط من تأكيد الطلب مما يضمن لك الحصول على كل العروض محدودة الوقت من أي متجر.'
                        : 'Within two hours from confirming your order which grantees getting all limited offers from any store'}
                    </p>
                    <Divider hidden />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={8} computer={5}>
                    <Image
                      size="tiny"
                      centered
                      src={require('./assets/Sec-2/icon_2-sec2.svg')}
                    />
                    <Header as="h3" style={{ textAlign: 'center' }}>
                      {isAr ? 'شحن دولي سريع' : 'Fast international shipping'}
                    </Header>
                    <p
                      style={{
                        color: '#7a7a7a',
                        fontSize: '1.25rem',
                      }}
                    >
                      {isAr
                        ? 'لكل الطلبات في لينكس من دون استثناء مدة الشحن الدولي والتوصيل تتراوح بين 14 يوم وحتى 21 يوم.'
                        : 'For all Lynks orders the shipping duration is between 14 to 21 days without exception'}
                    </p>
                    <Divider hidden />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={8} computer={5}>
                    <Image
                      size="tiny"
                      centered
                      src={require('./assets/Sec-2/icon_3-sec2.svg')}
                    />
                    <Header as="h3" style={{ textAlign: 'center' }}>
                      {isAr ? 'خدمة المساعد الشخصي للتسوق' : 'Shopping guide'}
                    </Header>
                    <p
                      style={{
                        color: '#7a7a7a',
                        fontSize: '1.25rem',
                      }}
                    >
                      {isAr
                        ? 'والذي يقوم بمساعدتك لشراء الخيار الأنسب لك من المتاجر المختلفة بناءً على تفضيلاتك وأولوياتك.'
                        : 'Who guides you to buy what is best for you from different stores upon to your preferences and priorities'}
                    </p>
                    <Divider hidden />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </div>
          <div className={styles.section3}>
            <Container
              style={{ padding: '5em 0' }}
              className={styles.sectoin3__container}
            >
              <Header
                as="h1"
                size="huge"
                style={{ textAlign: 'center' }}
                id={styles.mainHeader}
              >
                {isAr
                  ? 'لينكس...تسوق سهل و آمن'
                  : 'Experience effortless shopping with Lynks'}
              </Header>
              {!isAr && (
                <Header
                  style={{
                    padding: '0.5rem',
                    width: 'fit-content',
                    margin: '0 auto',
                    fontSize: '2rem',
                    color: '#7a7a7a',
                  }}
                >
                  Safe, Simple, and Secure
                </Header>
              )}
              <Divider section hidden />
              <Grid>
                <Grid.Row reversed={isAr ? 'computer' : false}>
                  <Grid.Column
                    mobile={16}
                    tablet={7}
                    computer={7}
                    textAlign="center"
                    verticalAlign="middle"
                  >
                    <Image
                      src={require('./assets/Sec-3/sec-3_object.png')}
                      centered
                      size="huge"
                      className={styles.section3__image}
                    />
                  </Grid.Column>

                  <Grid.Column
                    mobile={16}
                    tablet={9}
                    computer={9}
                    verticalAlign="middle"
                  >
                    <List bulleted dir={isAr ? 'rtl' : 'ltr'} size="huge">
                      <List.Item className={styles.listItem}>
                        <List.Content>
                          <List.Header
                            style={{
                              fontSize: '2rem',
                              color: '#4F97FB',
                              wordSpacing: '0.2em',
                              lineHeight: '1.2em',
                            }}
                          >
                            {isAr
                              ? 'تأمين ضد التلف'
                              : 'Insurance against damage'}
                          </List.Header>

                          <List.Description
                            style={{ margin: '1em 0', color: '#7a7a7a' }}
                          >
                            {isAr
                              ? 'تأمين مجاني على طلبك'
                              : 'Protect your order with free insurance'}
                          </List.Description>
                        </List.Content>
                      </List.Item>
                      <Divider hidden />
                      <List.Item className={styles.listItem}>
                        <List.Content>
                          <List.Header
                            style={{
                              fontSize: '2rem',
                              color: '#4F97FB',
                              wordSpacing: '0.2em',
                              lineHeight: '1.2em',
                            }}
                          >
                            {isAr
                              ? 'ميزة الاسترجاع السهل'
                              : 'Easy return policy'}
                          </List.Header>
                          <List.Description
                            style={{ margin: '1em 0', color: '#7a7a7a' }}
                          >
                            {isAr
                              ? 'سياسة استرجاع سهلة للمنتجات'
                              : 'Take advantage of our easy return policy for your purchases'}
                          </List.Description>
                        </List.Content>
                      </List.Item>
                      <Divider hidden />
                      <List.Item className={styles.listItem}>
                        <List.Content>
                          <List.Header
                            style={{
                              fontSize: '2rem',
                              color: '#4F97FB',
                              wordSpacing: '0.2em',
                              lineHeight: '1.2em',
                            }}
                          >
                            {isAr ? 'خيارات دفع متعددة' : 'Payment options'}
                          </List.Header>
                          <List.Description
                            style={{ margin: '1em 0', color: '#7a7a7a' }}
                          >
                            {isAr
                              ? 'الدفع فيزا ، كاش أو بالتقسيط مع ValU'
                              : 'Pay cash, Visa, or ValU'}
                          </List.Description>
                        </List.Content>
                      </List.Item>
                      <Divider hidden />
                      <List.Item className={styles.listItem}>
                        <List.Content>
                          <List.Header
                            style={{
                              fontSize: '2rem',
                              color: '#4F97FB',
                              wordSpacing: '0.2em',
                              lineHeight: '1.2em',
                            }}
                          >
                            {isAr
                              ? 'كاش باك لكل عملية شرائية'
                              : 'Cashback on every purchase'}
                          </List.Header>
                          <List.Description
                            style={{ margin: '1em 0', color: '#7a7a7a' }}
                          >
                            {isAr
                              ? 'كاش باك لعملاء لينكس المميزين يصل إلى 10%'
                              : '10% cashback for Lynks special customers'}
                          </List.Description>
                        </List.Content>
                      </List.Item>
                    </List>

                    <Divider section hidden />

                    <Button
                      size="massive"
                      style={{
                        borderRadius: '1rem',
                        padding: '2rem 2.5rem',
                        backgroundColor: '#ff5400',
                        color: '#fff',
                        fontSize: '2rem',
                      }}
                      as="a"
                      href={Routes.Cart}
                      className={styles.CTAButton}
                    >
                      {isAr ? 'جرّب بنفسك' : 'Try Lynks'}
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </div>
          <div style={{ backgroundColor: '#41C2F1' }}>
            <Container id="stores" style={{ padding: '5em 0' }}>
              <Header as="h1" textAlign="center" id={styles.mainHeader}>
                {isAr
                  ? 'متاجر عالمية كانت ضمن الأكثر بيعاً على موقعنا في 2022'
                  : 'Best selling international stores in 2022'}
              </Header>

              <Divider section hidden />

              <Card.Group itemsPerRow={rowCount}>
                {stores.map((store) => (
                  <Card
                    key={store.name}
                    href={store.url}
                    target="_blank"
                    link
                    raised
                    style={{ display: 'block' }}
                    image={
                      <Image
                        style={{
                          objectFit: 'cover',
                          objectPosition: 'center',
                          width: '100%',
                          aspectRatio: '1/1',
                          background: '#fff',
                          display: 'block',
                        }}
                        src={store.img}
                      />
                    }
                  />
                ))}
              </Card.Group>

              <Divider section hidden />
              <Header as="h1" textAlign="center" id={styles.mainHeader}>
                {isAr
                  ? 'أفضل العروض المختارة بعناية يمكنك إيجادها في لينكس شوب'
                  : 'Discover an amazing selection of products at Lynks shop'}
              </Header>
              <Header
                size="meduim"
                style={{
                  textAlign: 'center',
                  fontWeight: 'normal',
                }}
              >
                {isAr
                  ? 'اشتري أفضل القطع من ماركات عالمية مختلفة في أمريكا والعالم من متجر لينكس بسعر محدد'
                  : 'Buy from top international brands in the Us and around the world with unbeatable prices and fast delivery within'}
                <br />
                {isAr
                  ? 'وتوصيل خلال'
                  : 'with a competitive price and get them delivered by'}
                <span style={{ fontWeight: 'bold' }}>
                  {' '}
                  5 {isAr ? 'أيام' : 'days'}{' '}
                </span>
                {isAr
                  ? 'فقط للمنتجات الموجودة بالفعل.'
                  : 'only for all express deals in our shop'}
              </Header>
              <Grid
                columns="equal"
                textAlign="center"
                style={{ marginTop: '2rem' }}
              >
                {this.state.loading ? (
                  <Grid.Row>
                    <Grid.Column computer={4}>
                      <ShopCard loading={this.state.loading} />
                    </Grid.Column>
                    <Grid.Column computer={4}>
                      <ShopCard loading={this.state.loading} />
                    </Grid.Column>
                    <Grid.Column computer={4}>
                      <ShopCard loading={this.state.loading} />
                    </Grid.Column>
                  </Grid.Row>
                ) : (
                  <Grid.Row>
                    {this.state.products.length &&
                      sampleSize(this.state.products, 3).map((product) => (
                        <Grid.Column
                          computer={4}
                          tablet={16}
                          mobile={16}
                          key={product.id}
                          style={{ marginBottom: '1.5rem' }}
                        >
                          <ShopCard
                            image={
                              (product.defaultPhoto &&
                                product.defaultPhoto.url_small &&
                                product.defaultPhoto.url_small) ||
                              product.defaultVariation.photos[0].url_small
                            }
                            title={product.title}
                            listPriceEgp={product.defaultVariation.listPriceEgp}
                            priceEgp={product.defaultVariation.priceEgp}
                            slug={product.slug}
                            sortedSelectors={product.sortedSelectors}
                            defaultVariation={product.defaultVariation}
                            variations={product.variations}
                            minShippingDays={product.minShippingDays}
                            maxShippingDays={product.maxShippingDays}
                          />
                        </Grid.Column>
                      ))}
                  </Grid.Row>
                )}
              </Grid>
              <Header
                as="h1"
                textAlign="center"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <a
                  href="https://shop.lynks.com/"
                  target="_blank"
                  style={{
                    color: '#fff',
                    border: '2px solid #fff',
                    padding: '1rem',
                    borderRadius: '1rem',
                  }}
                  className={styles.gtShop}
                >
                  {isAr ? 'تصفح المزيد من العروض' : 'Show more offers'}

                  <Icon
                    name={`${isAr ? 'left' : 'right'} arrow`}
                    size="tiny"
                    style={{ fontSize: '2rem', margin: '0 .75rem' }}
                  />
                </a>
              </Header>
            </Container>
          </div>
          <div className={styles.reviews}>
            <Container id="reviews" style={{ padding: '5em 0' }}>
              <Header as="h1" textAlign="center" id={styles.mainHeader}>
                {isAr
                  ? 'شوف آراء عملائنا في آخر 3 شهور'
                  : 'Check our customers reviews in the last 3 months'}
              </Header>

              <Divider section hidden />
              <OwlCarousel
                autoplay
                loop
                nav
                className={styles.owlPrev}
                items={1}
                margin={0}
                style={{ touchAction: 'none' }}
              >
                {testimonials.map((tes) => (
                  <div className="item" style={{ height: '100%' }} key={tes.id}>
                    <Image
                      size="huge"
                      centered
                      src={tes.src}
                      style={{ zIndex: '3', borderRadius: '1rem' }}
                    />
                  </div>
                ))}
              </OwlCarousel>
            </Container>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(injectIntl, withRouter, injectLayout)(ComeBack);



// WEBPACK FOOTER //
// ./app/containers/StaticPage/ComeBack/index.js